<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast/>
                <Toolbar class="mb-4" v-if="!permissionDenied">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button label="Törlés" icon="pi pi-trash" class="p-button-danger"
                                    @click="confirmDeleteSelected" :disabled="!selectedUsers || !selectedUsers.length"/>
                        </div>
                    </template>

                    <template v-slot:end>
                        <Button label="Export" icon="pi pi-download" class="p-button-help" @click="exportToExcel"/>
                    </template>
                </Toolbar>

                <DataTable ref="dt" :value="users" v-model:selection="selectedUsers" dataKey="id" :paginator="true"
                           :rows="10" :filters="filters" :loading="loading"
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           :rowsPerPageOptions="[5,10,25]"
                           currentPageReportTemplate="" responsiveLayout="scroll" filterDisplay="row"
                           v-model:filters="filters"
                           :globalFilterFields="['userName','nameHU','email','status','childrenNames','parentRoleLabel']">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0">Felhasználók <br> <strong><small>Összesen: {{ total }}</small></strong></h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global'].value" placeholder="Keresés..."/>
                            </span>
                        </div>
                    </template>

                    <Column selectionMode="multiple" headerStyle="width: 1rem"></Column>
                    <Column field="id" header="#" :sortable="true" headerStyle="width:2%; min-width:5rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">#</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column field="userName" header="Felhasználónév" :sortable="true"
                            headerStyle="width:15%; min-width:10rem;" :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">Felhasználónév</span>
                            {{ slotProps.data.userName }}
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                       class="p-column-filter" :placeholder="`Keresés...`"/>
                        </template>
                    </Column>
                    <Column field="nameHU" header="Név" :sortable="true" headerStyle="width:15%; min-width:10rem;"
                            :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">Név</span>
                            {{ slotProps.data.nameHU }}
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                       class="p-column-filter" :placeholder="`Keresés...`"/>
                        </template>
                    </Column>
                    <Column field="email" header="E-mail cím" :sortable="true" headerStyle="width:15%; min-width:10rem;"
                            :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">E-mail cím</span>
                            {{ slotProps.data.email }}
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                       class="p-column-filter" :placeholder="`Keresés...`"/>
                        </template>
                    </Column>
                    <Column field="createdAt" header="Regisztráció dátuma" :sortable="true"
                            headerStyle="width:15%; min-width:10rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">Regisztráció dátuma</span>
                            {{ slotProps.data.createdAt }}
                        </template>
                    </Column>
                    <Column field="status" header="Státusz" :sortable="true" headerStyle="width:20%; min-width:10rem;"
                            :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">Státusz</span>

                            <span class="product-badge status-instock"
                                  v-if="slotProps.data.status === 'active'">Aktív</span>
                            <span class="product-badge status-lowstock" v-else>Inaktív</span>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="statuses"
                                      placeholder="Összes"
                                      class="p-column-filter" :showClear="true" optionLabel="label" optionValue="value">
                                <template #value="slotProps">
                                <span v-if="slotProps.value">
                                    <span v-if="slotProps.value === 'active'">Aktív</span>
                                    <span v-else>Inaktív</span>
                                </span>
                                    <span v-else>{{ slotProps.placeholder }}</span>
                                </template>
                                <template #option="slotProps">
                                    {{ slotProps.option.label }}
                                </template>
                            </Dropdown>
                        </template>
                    </Column>
                    <Column field="parentRole" header="Szerep" :sortable="true"
                            headerStyle="width:12%; min-width:9rem;" :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">Szerep</span>
                            <span class="product-badge status-instock"
                                  v-if="slotProps.data.parentRole === 'primary'">Elsődleges</span>
                            <span class="product-badge status-lowstock"
                                  v-else-if="slotProps.data.parentRole === 'secondary'">Másodlagos</span>
                            <span v-else>—</span>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="parentRoles"
                                      placeholder="Összes"
                                      class="p-column-filter" :showClear="true" optionLabel="label" optionValue="value">
                                <template #value="slotProps">
                                    <span v-if="slotProps.value === 'primary'">Elsődleges</span>
                                    <span v-else-if="slotProps.value === 'secondary'">Másodlagos</span>
                                    <span v-else>{{ slotProps.placeholder }}</span>
                                </template>
                                <template #option="slotProps">
                                    {{ slotProps.option.label }}
                                </template>
                            </Dropdown>
                        </template>
                    </Column>
                    <Column headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                    v-tooltip.top="'Szerkesztés'" @click="edit(slotProps.data)"/>
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-primary mr-2"
                                    v-tooltip.top="'Megtekintés'" @click="show(slotProps.data)"/>
                            <br>
                            <ConfirmPopup></ConfirmPopup>
                            <Button icon="pi pi-sign-in" class="p-button-rounded p-button-secondary mr-2"
                                    v-if="!permissionDenied"
                                    v-tooltip.top="'Belépés a nevében'" @click="login($event, slotProps.data)"/>
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mt-2"
                                    v-if="!permissionDenied"
                                    v-tooltip.top="'Törlés'" @click="confirmDelete(slotProps.data)"/>
                        </template>
                    </Column>
                    <template #empty>
                        Nincs egyetlen felhasználó sem.
                    </template>
                </DataTable>

                <Dialog v-model:visible="userDialog" :style="{width: '800px'}" header="Felhasználó adatai" :modal="true"
                        class="p-fluid">
                    <TabView :style="{minHeight: '500px'}">
                        <TabPanel header="Alapadatok">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="lastName">Vezetéknév</label>
                                    <InputText id="lastName" v-model.trim="user.lastName" required="true"
                                               :class="{'p-invalid': submitted && !user.lastName}"/>
                                    <small class="p-invalid" v-if="submitted && !user.lastName">Vezetéknév megadása
                                        kötelező.</small>
                                </div>
                                <div class="field col">
                                    <label for="firstName">Keresztnév</label>
                                    <InputText id="firstName" v-model.trim="user.firstName" required="true"
                                               :class="{'p-invalid': submitted && !user.firstName}"/>
                                    <small class="p-invalid" v-if="submitted && !user.firstName">Keresztnév megadása
                                        kötelező.</small>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="name">Házirend</label> <br>
                                    <InputSwitch v-model="user.policyAccepted"/>
                                </div>

                                <div class="field col">
                                    <label for="name">Adatvédelmi szabályzat</label> <br>
                                    <InputSwitch v-model="user.privacyPolicyAccepted"/>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="name">Igazolatlan módon mulasztott ő vagy gyermeke foglalkozást</label>
                                    <br>
                                    <InputSwitch v-model="user.unexcusedAbsence"/>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="name">Tiltott státusz</label> <br>
                                    <InputSwitch v-model="user.isForbidden"/>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="name">Beszélt nyelvek</label>
                                    <MultiSelect id="gameProperty" ::modelValue="languageIds" v-model="languageIds"
                                                 :options="languages" :emptyMessage="'Nincs találat'"
                                                 optionLabel="name" optionValue="id" :filter="true" filterBy="name"
                                                 :showClear="true" placeholder="Kérlek válassz...">
                                        <template #option="slotProps">
                                            <div class="flex align-items-center">
                                                <div>{{ slotProps.option.name }}</div>
                                            </div>
                                        </template>
                                    </MultiSelect>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="inventoryStatus">Státusz</label>
                                    <Dropdown id="inventoryStatus" v-model="user.status" :options="statuses"
                                              optionLabel="label" placeholder="Státusz">
                                        <template #value="slotProps">
                                            <span v-if="slotProps.value">
                                                <span class="product-badge status-instock"
                                                      v-if="slotProps.value == 'active' || slotProps.value.value == 'active'">
                                                    Aktív
                                                </span>
                                                <span class="product-badge status-lowstock" v-else>Inaktív</span>
                                            </span>
                                            <span v-else>
                                                {{ slotProps.placeholder }}
                                            </span>
                                        </template>
                                    </Dropdown>
                                </div>
                                <div class="field col">
                                    <label for="name">Aktiválás dátuma</label>
                                    <Calendar inputId="calendar" v-model="actualDate" :disabledDays="[0,6]"
                                              :manualInput="false" dateFormat="yy-mm-dd"></Calendar>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Elérhetőségek">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="lastName">Irányítószám</label>
                                    <InputText id="lastName" v-model.trim="user.contactDetail.zipCode" required="true"
                                               :class="{'p-invalid': submitted && !user.contactDetail.zipCode}"/>
                                    <small class="p-invalid" v-if="submitted && !user.contactDetail.zipCode">Irányítószám
                                        megadása kötelező.</small>
                                </div>
                                <div class="field col">
                                    <label for="street">Közterület</label>
                                    <Dropdown id="street" v-model="user.contactDetail.street"
                                              :options="streets" optionLabel="name" optionValue="name"
                                              placeholder="Válasszon közterületet..." :filter="true"
                                              :class="{'p-invalid': submitted && !user.contactDetail.street}"/>
                                    <small class="p-invalid" v-if="submitted && !user.contactDetail.street">Közterület
                                        megadása kötelező.</small>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="lastName">Házszám</label>
                                    <InputText id="lastName" v-model.trim="user.contactDetail.houseNumber"
                                               required="true"
                                               :class="{'p-invalid': submitted && !user.contactDetail.houseNumber}"/>
                                    <small class="p-invalid" v-if="submitted && !user.contactDetail.houseNumber">Házszám
                                        megadása kötelező.</small>
                                </div>
                                <div class="field col">
                                    <label for="firstName">Emelet</label>
                                    <InputText id="floor" v-model.trim="user.contactDetail.floor"/>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="lastName">Ajtó</label>
                                    <InputText id="door" v-model.trim="user.contactDetail.door"/>
                                </div>
                                <div class="field col">
                                    <label for="firstName">Telefonszám</label>
                                    <InputText id="firstName" v-model.trim="user.contactDetail.phoneNumber"
                                               required="true"
                                               :class="{'p-invalid': submitted && !user.contactDetail.phoneNumber}"/>
                                    <small class="p-invalid" v-if="submitted && !user.contactDetail.phoneNumber">Telefonszám
                                        megadása kötelező.</small>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>


                    <template #footer>
                        <Button label="Mégse" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
                        <Button label="Mentés" icon="pi pi-check" class="p-button-success" @click="saveUser"
                                :loading="loading"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="showUserDialog" :style="{width: '1000px'}" header="Felhasználó adatai"
                        :modal="true" class="p-fluid">
                    <div class="surface-card" v-if="!loading">
                        <TabView :style="{minHeight: '600px'}">
                            <TabPanel header="Alapadatok">
                                <ul class="list-none p-0 m-0 border-top-1 border-300">
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">ID</div>
                                        <div class="text-900 w-full md:w-5">{{ user.id }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Felhasználónév</div>
                                        <div class="text-900 w-full md:w-5">{{ user.userName }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Név</div>
                                        <div class="text-900 w-full md:w-5">{{ user.nameHU }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">E-mail cím</div>
                                        <div class="text-900 w-full md:w-5">{{ user.email }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Státusz</div>
                                        <div class="text-900 w-full md:w-5">{{
                                                user.isActive ? 'Aktív' : 'Inaktív'
                                            }}
                                        </div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Tiltott státusz</div>
                                        <div class="text-900 w-full md:w-5">{{
                                                user.isForbidden ? 'Igen' : 'Nem'
                                            }}
                                        </div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Házirendet elfogadta</div>
                                        <div class="text-900 w-full md:w-5">{{
                                                user.policyAccepted ? 'Igen' : 'Nem'
                                            }}
                                        </div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Adatvédelmi szabályzatot
                                            elfogadta
                                        </div>
                                        <div class="text-900 w-full md:w-5">
                                            {{ user.privacyPolicyAccepted ? 'Igen' : 'Nem' }}
                                        </div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Szeretne hírlevelet</div>
                                        <div class="text-900 w-full md:w-5">
                                            {{ user.newsletter ? 'Igen' : 'Nem' }}
                                        </div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Igazolatlan módon mulasztott
                                        </div>
                                        <div class="text-900 w-full md:w-5">{{
                                                user.unexcusedAbsence ? 'Igen' : 'Nem'
                                            }}
                                        </div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Beszélt nyelvek</div>
                                        <div class="text-900 w-full md:w-5">
                                            <span v-if="user.languages.length > 0">{{
                                                    user.languages.map((lang) => lang.name).join(",")
                                                }}</span>
                                            <span v-else>Nincsenek beállítva</span>
                                        </div>
                                    </li>
                                </ul>
                            </TabPanel>
                            <TabPanel header="Elérhetőségek">
                                <ul class="list-none p-0 m-0 border-top-1 border-300">
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Irányítószám</div>
                                        <div class="text-900 w-full md:w-5">{{ user.contactDetail.zipCode }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Közterület</div>
                                        <div class="text-900 w-full md:w-5">{{ user.contactDetail.street }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Házszám</div>
                                        <div class="text-900 w-full md:w-5">{{ user.contactDetail.houseNumber }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Emelet</div>
                                        <div class="text-900 w-full md:w-5">{{ user.contactDetail.floor }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                        <div class="text-500 w-full md:w-5 font-medium">Ajtó</div>
                                        <div class="text-900 w-full md:w-5">{{ user.contactDetail.door }}</div>
                                    </li>
                                    <li class="flex align-items-center py-3 px-2 flex-wrap">
                                        <div class="text-500 w-full md:w-5 font-medium">Telefonszám</div>
                                        <div class="text-900 w-full md:w-5">{{ user.contactDetail.phoneNumber }}</div>
                                    </li>
                                </ul>
                            </TabPanel>
                            <TabPanel header="Gyermekek">
                                <DataTable :value="user.children" class="mt-3" responsiveLayout="scroll">
                                    <Column field="id" header="#" :style="{width:'100px'}"></Column>
                                    <Column field="nameHU" header="Név"></Column>
                                    <Column field="gender" header="Nem"></Column>
                                    <Column field="birthDate" header="Születésnap"></Column>
                                    <Column field="age" header="Életkor"></Column>
                                    <Column field="acclimatization" header="Beszoktatós">
                                        <template #body="slotProps">
                                            <span class="p-column-title">Beszoktatós</span>
                                            {{ slotProps.data.acclimatization ? 'Igen' : 'Nem' }}
                                        </template>
                                    </Column>
                                    <Column>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-eye" class="p-button-rounded p-button-primary mr-2"
                                                    v-tooltip.top="'Megtekintés'" @click="showChild(slotProps.data)"/>
                                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                                    v-tooltip.top="'Szerkesztés'" @click="editChild(slotProps.data)"/>
                                            <Button icon="pi pi-users" class="p-button-rounded p-button-secondary mr-2"
                                                    v-tooltip.top="'Kapcsolattartók'" @click="showConnections(slotProps.data)"/>
                                            <Button icon="pi pi-link" class="p-button-rounded p-button-info mr-2"
                                                    v-tooltip.top="'Kapcsolt szülők'" @click="showChildParents(slotProps.data)"/>
                                        </template>
                                    </Column>
                                </DataTable>

                                <div v-if="user.linkedChildren && user.linkedChildren.length > 0" class="mt-4">
                                    <h6>Szülő-gyermek kapcsolatok</h6>
                                    <DataTable :value="user.linkedChildren" class="mt-2" responsiveLayout="scroll">
                                        <Column field="childName" header="Gyermek neve"></Column>
                                        <Column field="roleLabel" header="Szerep"></Column>
                                        <Column header="Hibernált">
                                            <template #body="slotProps">
                                                <span v-if="slotProps.data.isHibernated" class="p-badge p-badge-warning">Hibernált</span>
                                                <span v-else class="p-badge p-badge-success">Aktív</span>
                                            </template>
                                        </Column>
                                        <Column header="Műveletek" v-if="!permissionDenied">
                                            <template #body="slotProps">
                                                <Button
                                                    :icon="slotProps.data.isHibernated ? 'pi pi-play' : 'pi pi-pause'"
                                                    :class="slotProps.data.isHibernated ? 'p-button-rounded p-button-success mr-2' : 'p-button-rounded p-button-warning mr-2'"
                                                    v-tooltip.top="slotProps.data.isHibernated ? 'Aktiválás' : 'Hibernálás'"
                                                    @click="toggleHibernation(slotProps.data)"/>
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Dokumentumok">
                                <div class="mb-3">
                                    <h5>Dokumentum feltöltése</h5>
                                    <div class="formgrid grid">
                                        <div class="field col-5">
                                            <label>Fájl kiválasztása</label>
                                            <input type="file" class="p-inputtext p-component w-full" @change="onDocumentFileSelect" />
                                        </div>
                                        <div class="field col-5">
                                            <label>Leírás (opcionális)</label>
                                            <InputText v-model="documentDescription" placeholder="Pl. Szakvélemény" class="w-full" />
                                        </div>
                                        <div class="field col-2 flex align-items-end">
                                            <Button label="Feltöltés" icon="pi pi-upload" class="p-button-success w-full"
                                                    @click="uploadDocument" :loading="documentUploading"
                                                    :disabled="!documentFile" />
                                        </div>
                                    </div>
                                </div>
                                <DataTable :value="documents" class="mt-3" responsiveLayout="scroll" :loading="documentsLoading">
                                    <Column field="id" header="#" :style="{width:'80px'}"></Column>
                                    <Column field="originalName" header="Fájlnév"></Column>
                                    <Column field="description" header="Leírás"></Column>
                                    <Column field="uploadedByAdmin" header="Feltöltő">
                                        <template #body="slotProps">
                                            {{ slotProps.data.uploadedByAdmin ? 'Admin' : 'Felhasználó' }}
                                        </template>
                                    </Column>
                                    <Column field="createdAt" header="Feltöltve"></Column>
                                    <Column header="Műveletek">
                                        <template #body="slotProps">
                                            <Button icon="pi pi-download" class="p-button-rounded p-button-info mr-2"
                                                    v-tooltip.top="'Letöltés'" @click="downloadDocument(slotProps.data)" />
                                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                                    v-tooltip.top="'Törlés'" @click="deleteDocument(slotProps.data)" />
                                        </template>
                                    </Column>
                                    <template #empty>
                                        Nincsenek feltöltött dokumentumok.
                                    </template>
                                </DataTable>
                            </TabPanel>
                            <TabPanel header="Jelentkezések">
                                <div class="formgrid grid mb-3">
                                    <div class="field col-12 md:col-3">
                                        <label for="filterDateFrom">Dátumtól</label>
                                        <Calendar id="filterDateFrom" v-model="applyFilterDateFrom"
                                                  dateFormat="yy-mm-dd"
                                                  :showIcon="true"
                                                  placeholder="Válassz kezdő dátumot"
                                                  @date-select="filterAppliesByDate"/>
                                    </div>
                                    <div class="field col-12 md:col-3">
                                        <label for="filterDateTo">Dátumig</label>
                                        <Calendar id="filterDateTo" v-model="applyFilterDateTo"
                                                  dateFormat="yy-mm-dd"
                                                  :showIcon="true"
                                                  placeholder="Válassz vég dátumot"
                                                  @date-select="filterAppliesByDate"/>
                                    </div>
                                    <div class="field col-12 md:col-3">
                                        <label for="filterApplicantType">Jelentkező típusa</label>
                                        <Dropdown id="filterApplicantType"
                                                  v-model="applyFilterApplicantType"
                                                  :options="applicantTypes"
                                                  optionLabel="label"
                                                  optionValue="value"
                                                  placeholder="Összes"
                                                  :showClear="true"
                                                  @change="filterAppliesByDate"/>
                                    </div>
                                    <div class="field col-12 md:col-3 flex align-items-end">
                                        <Button label="Szűrő törlése"
                                                icon="pi pi-times"
                                                class="p-button-outlined p-button-secondary"
                                                @click="clearApplyDateFilter"/>
                                    </div>
                                </div>
                                <DataTable :value="filteredApplies" class="mt-3" responsiveLayout="scroll" :paginator="true" :rows="10">
                                    <Column field="id" header="#" :style="{width:'80px'}"></Column>
                                    <Column header="Várólistás" :style="{width:'120px'}">
                                        <template #body="slotProps">
                                            <span v-if="slotProps.data.isWaitingList" class="p-badge p-badge-warning">Várólista</span>
                                            <span v-else class="p-badge p-badge-success">Aktív</span>
                                        </template>
                                    </Column>
                                    <Column field="event.name" header="Esemény neve" :style="{minWidth:'200px'}">
                                        <template #body="slotProps">
                                            <span :class="{'font-bold': slotProps.data.isWaitingList}">{{ slotProps.data.event.name }}</span>
                                        </template>
                                    </Column>
                                    <Column header="Jelentkező" :style="{minWidth:'150px'}">
                                        <template #body="slotProps">
                                            <span v-if="slotProps.data.child">{{ slotProps.data.child.name }}</span>
                                            <span v-else-if="slotProps.data.parent">{{ slotProps.data.parent.name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="applyDate" header="Időpont" :style="{minWidth:'150px'}"></Column>
                                    <Column field="createdAt" header="Jelentkezés dátuma" :style="{minWidth:'150px'}"></Column>
                                </DataTable>
                            </TabPanel>
                        </TabView>
                    </div>
                </Dialog>

                <Dialog v-model:visible="showChildDialog" :style="{width: '800px'}" header="Gyermek adatai"
                        :modal="true" class="p-fluid">
                    <div class="surface-card" v-if="!loading" :style="{minHeight: '600px'}">
                        <ul class="list-none p-0 m-0 border-top-1 border-300">
                            <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                <div class="text-500 w-full md:w-5 font-medium">Név</div>
                                <div class="text-900 w-full md:w-5">{{ child.name }}</div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap">
                                <div class="text-500 w-full md:w-5 font-medium">Nem</div>
                                <div class="text-900 w-full md:w-5">{{ child.gender }}</div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                <div class="text-500 w-full md:w-5 font-medium">Hogyan szólitsuk</div>
                                <div class="text-900 w-full md:w-5">{{ child.howToCall }}</div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap">
                                <div class="text-500 w-full md:w-5 font-medium">Születésnap</div>
                                <div class="text-900 w-full md:w-5">{{ child.birthDate }}</div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                <div class="text-500 w-full md:w-5 font-medium">Életkor</div>
                                <div class="text-900 w-full md:w-5">{{ child.age }}</div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                <div class="text-500 w-full md:w-5 font-medium">Beszoktatós</div>
                                <div class="text-900 w-full md:w-5">{{
                                        child.acclimatization ? 'Igen' : 'Nem'
                                    }}
                                </div>
                            </li>
                            <!--                            <li class="flex align-items-center py-3 px-2 flex-wrap">-->
                            <!--                                <div class="text-500 w-full md:w-5 font-medium">Telefonszám</div>-->
                            <!--                                <div class="text-900 w-full md:w-5">{{ child.phoneNumber }}</div>-->
                            <!--                            </li>-->
                            <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                <div class="text-500 w-full md:w-5 font-medium">Speciális igények</div>
                                <div class="text-900 w-full md:w-5">{{ child.specialRequirements }}</div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap">
                                <div class="text-500 w-full md:w-5 font-medium">Beszélt nyelvek</div>
                                <div class="text-900 w-full md:w-5">
                                    <span v-if="child.languages.length > 0">{{
                                            child.languages.map((lang) => lang.name).join(", ")
                                        }}</span>
                                    <span v-else>Nincsenek beállítva</span>
                                </div>
                            </li>
                            <li class="flex align-items-center py-3 px-2 flex-wrap surface-50">
                                <div class="text-500 w-full md:w-5 font-medium">Kapcsolatok</div>
                                <div class="text-900 w-full md:w-5">
                                    {{
                                        child.connections.map((connection) => connection.name + ' (' + connection.phoneNumber + ')').join(", ")
                                    }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </Dialog>

                <Dialog v-model:visible="editChildConnectionsDialog" :style="{width: '900px'}"
                        header="Gyermek kapcsolattartóinak szerkesztése" :modal="true" class="p-fluid">
                    <div class="surface-card" :style="{minHeight: '500px'}">
                        <div v-for="(connection, index) in childConnections" v-bind:key="index">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="lastName">Vezetéknév</label>
                                    <InputText id="lastName" v-model.trim="connection.lastName" required="true"
                                               :class="{'p-invalid': childConnectionSubmitted && !connection.lastName}"/>
                                    <small class="p-invalid" v-if="childConnectionSubmitted && !connection.lastName">Vezetéknév megadása
                                        kötelező.</small>
                                </div>
                                <div class="field col">
                                    <label for="firstName">Keresztnév</label>
                                    <InputText id="firstName" v-model.trim="connection.firstName" required="true"
                                               :class="{'p-invalid': childConnectionSubmitted && !connection.firstName}"/>
                                    <small class="p-invalid" v-if="childConnectionSubmitted && !connection.firstName">Keresztnév megadása
                                        kötelező.</small>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="lastName">Telefonszám</label>
                                    <InputText id="lastName" v-model.trim="connection.phoneNumber" required="true"
                                               :class="{'p-invalid': childConnectionSubmitted && !connection.phoneNumber}"/>
                                    <small class="p-invalid" v-if="childConnectionSubmitted && !connection.phoneNumber">Telefonszám megadása
                                        kötelező.</small>
                                </div>
                                <div class="field col">
                                    <label for="firstName">Kapcsolata a gyermekkel</label>
                                    <InputText id="firstName" v-model.trim="connection.relationshipType" required="true"
                                               :class="{'p-invalid': childConnectionSubmitted && !connection.relationshipType}"/>
                                    <small class="p-invalid" v-if="childConnectionSubmitted && !connection.relationshipType">Kapcsolata a gyermekkel megadása
                                        kötelező.</small>
                                </div>
                            </div>

                            <div class="formgrid grid">
                                <div class="field col">
                                    <Button label="Törlés" icon="pi pi-trash" class="p-button-danger"
                                            @click="deleteConnection(index)" :style="{marginTop: '25px'}"/>
                                </div>
                            </div>
                            <hr>
                        </div>
                        <div class="formgrid grid">
                            <div class="field col">
                                <Button label="Új személy" icon="pi pi-plus" class="p-button-success" @click="addConnection" :style="{marginTop: '25px'}"/>
                            </div>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Mégse" icon="pi pi-times" class="p-button-text"
                                @click="editChildConnectionsDialog = false"/>
                        <Button label="Mentés" icon="pi pi-check" class="p-button-success" @click="saveChildConnection"
                                :loading="childConnectionsLoading"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="editChildDialog" :style="{width: '800px'}"
                        header="Gyermek adatainak szerkesztése" :modal="true" class="p-fluid">
                    <div class="surface-card" :style="{minHeight: '400px'}">
                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="lastName">Vezetéknév</label>
                                <InputText id="lastName" v-model.trim="child.lastName" required="true"
                                           :class="{'p-invalid': childSubmitted && !child.lastName}"/>
                                <small class="p-invalid" v-if="childSubmitted && !child.lastName">Vezetéknév megadása
                                    kötelező.</small>
                            </div>
                            <div class="field col">
                                <label for="firstName">Keresztnév</label>
                                <InputText id="firstName" v-model.trim="child.firstName" required="true"
                                           :class="{'p-invalid': childSubmitted && !child.firstName}"/>
                                <small class="p-invalid" v-if="childSubmitted && !child.firstName">Keresztnév megadása
                                    kötelező.</small>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="lastName">Hogyan szólítsuk a gyermeket?</label>
                                <InputText id="door" v-model.trim="child.howToCall"/>
                            </div>
                            <div class="field col">
                                <label for="firstName">Telefonszám</label>
                                <InputText id="firstName" v-model.trim="child.phoneNumber"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="lastName">Születési dátum</label>
                                <Calendar inputId="calendar" v-model="child.birthDate"
                                          :manualInput="false" dateFormat="yy-mm-dd"
                                          :class="{'p-invalid': childSubmitted && !child.birthDate}"></Calendar>
                            </div>
                            <div class="field col">
                                <label for="firstName">Nem</label>
                                <Dropdown id="inventoryStatus" v-model="child.genderSelect" :options="genders"
                                          optionLabel="label"
                                          :class="{'p-invalid': childSubmitted && !child.genderSelect}"
                                          placeholder="Nem">
                                    <template #value="slotProps">
                                            <span v-if="slotProps.value">
                                                {{ slotProps.value.label }}
                                            </span>
                                        <span v-else>
                                                {{ slotProps.placeholder }}
                                            </span>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="acclimatization">Beszoktatós</label> <br>
                                <InputSwitch v-model="child.acclimatization"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="lastName">Speciális igények</label>
                                <Textarea v-model="child.specialRequirements" rows="3" cols="20"/>
                            </div>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Mégse" icon="pi pi-times" class="p-button-text"
                                @click="editChildDialog = false"/>
                        <Button label="Mentés" icon="pi pi-check" class="p-button-success" @click="saveChild"
                                :loading="childLoading"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="childParentsDialog" :style="{width: '900px'}" header="Gyermekhez kapcsolt szülők"
                        :modal="true" class="p-fluid">
                    <div class="surface-card" :style="{minHeight: '300px'}">
                        <h6>{{ childParentsChildName }}</h6>
                        <DataTable :value="childParentsData" class="mt-3" responsiveLayout="scroll"
                                   :loading="childParentsLoading">
                            <Column field="userName" header="Szülő neve"></Column>
                            <Column field="userEmail" header="E-mail"></Column>
                            <Column field="roleLabel" header="Szerep"></Column>
                            <Column header="Hibernált">
                                <template #body="slotProps">
                                    <span v-if="slotProps.data.isHibernated" class="p-badge p-badge-warning">Hibernált</span>
                                    <span v-else class="p-badge p-badge-success">Aktív</span>
                                </template>
                            </Column>
                            <Column header="Műveletek" v-if="!permissionDenied">
                                <template #body="slotProps">
                                    <Button
                                        :icon="slotProps.data.isHibernated ? 'pi pi-play' : 'pi pi-pause'"
                                        :class="slotProps.data.isHibernated ? 'p-button-rounded p-button-success mr-2' : 'p-button-rounded p-button-warning mr-2'"
                                        v-tooltip.top="slotProps.data.isHibernated ? 'Aktiválás' : 'Hibernálás'"
                                        @click="toggleHibernationFromChildParents(slotProps.data)"/>
                                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger mr-2"
                                            v-tooltip.top="'Leválasztás'"
                                            @click="unlinkParentFromChild(slotProps.data)"
                                            :disabled="childParentsData.length <= 1"/>
                                </template>
                            </Column>
                            <template #empty>
                                Nincsenek kapcsolt szülők.
                            </template>
                        </DataTable>

                        <div class="mt-4" v-if="!permissionDenied">
                            <Button label="Új szülő hozzákapcsolása" icon="pi pi-plus" class="p-button-success"
                                    @click="openLinkParentDialog"/>
                        </div>
                    </div>
                </Dialog>

                <Dialog v-model:visible="linkParentDialog" :style="{width: '600px'}" header="Szülő hozzákapcsolása gyermekhez"
                        :modal="true" class="p-fluid">
                    <div class="surface-card" :style="{minHeight: '250px'}">
                        <div class="field">
                            <label>Szülő keresése (név vagy e-mail)</label>
                            <InputText v-model="linkParentSearchQuery" placeholder="Keresés..."
                                       @input="searchParentsForLinking"/>
                        </div>
                        <div class="field" v-if="linkParentSearchResults.length > 0">
                            <label>Válasszon szülőt</label>
                            <Dropdown v-model="linkParentSelectedUser" :options="linkParentSearchResults"
                                      optionLabel="label" placeholder="Válasszon...">
                                <template #option="slotProps">
                                    {{ slotProps.option.label }}
                                </template>
                            </Dropdown>
                        </div>
                        <div class="field">
                            <label>Szerep</label>
                            <Dropdown v-model="linkParentRole" :options="parentRoles"
                                      optionLabel="label" optionValue="value" placeholder="Válasszon szerepet..."/>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Mégse" icon="pi pi-times" class="p-button-text"
                                @click="linkParentDialog = false"/>
                        <Button label="Hozzákapcsolás" icon="pi pi-check" class="p-button-success"
                                @click="linkParent" :loading="linkParentLoading"
                                :disabled="!linkParentSelectedUser"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="deleteUserDialog" :style="{width: '550px'}" header="Törlés megerősítése"
                        :modal="true">
                    <div class="flex align-items-center justify-content-center mt-3">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"/>
                        <span
                            v-if="user">Biztosan törölni szeretné a következő felhasználót: <br> <b>{{ user.name }}</b>?</span>
                    </div>
                    <template #footer>
                        <Button label="Nem" icon="pi pi-times" class="p-button-text" @click="deleteUserDialog = false"/>
                        <Button label="Igen" icon="pi pi-check" class="p-button-danger" @click="deleteUser" :loading="deleteLoading"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="deleteUsersDialog" :style="{width: '550px'}" header="Törlés megerősítése"
                        :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"/>
                        <span v-if="user">Biztosan törölni szeretné a kiválasztott felhasználókat?</span>
                    </div>
                    <template #footer>
                        <Button label="Nem" icon="pi pi-times" class="p-button-text"
                                @click="deleteUsersDialog = false"/>
                        <Button label="Igen" icon="pi pi-check" class="p-button-danger" @click="deleteSelectedUsers"/>
                    </template>
                </Dialog>
            </div>
        </div>
    </div>

</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import UserService from "@/service/UserService";
import DocumentService from "@/service/DocumentService";
import ParentChildService from "@/service/ParentChildService";
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";
import LanguageService from "@/service/LanguageService";
import StreetService from "@/service/StreetService";
import ChildService from "@/service/ChildService";
import * as dayjs from "dayjs";
import ExcelJS from 'exceljs';

export default {
    data() {
        return {
            total: 0,
            users: null,
            showUserDialog: false,
            showChildDialog: false,
            editChildDialog: false,
            editChildConnectionsDialog: false,
            userDialog: false,
            deleteUserDialog: false,
            deleteUsersDialog: false,
            user: {},
            child: {},
            childConnections: [],
            connectionSubmitted: false,
            selectedUsers: null,
            filters: {},
            submitted: false,
            childSubmitted: false,
            childConnectionSubmitted: false,
            childConnectionsLoading: false,
            loading: true,
            deleteLoading: false,
            childLoading: false,
            childConnectionLoading: false,
            permissionDenied: true,
            actualDate: null,
            applyFilterDateFrom: null,
            applyFilterDateTo: null,
            applyFilterApplicantType: null,
            filteredApplies: [],
            applicantTypes: [
                {
                    label: 'Felnőtt (szülő)', value: 'parent'
                },
                {
                    label: 'Gyerek', value: 'child'
                }
            ],
            statuses: [
                {
                    label: 'Aktív', value: 'active'
                },
                {
                    label: 'Inaktív', value: 'inactive'
                }
            ],
            forbiddenStatuses: [
                {
                    label: 'Aktív', value: 'active'
                },
                {
                    label: 'Tiltott', value: 'inactive'
                }
            ],
            genders: [
                {
                    label: 'Fiú', value: '0'
                },
                {
                    label: 'Lány', value: '1'
                },
            ],
            parentRoles: [
                {
                    label: 'Elsődleges szülő', value: 'primary'
                },
                {
                    label: 'Másodlagos szülő', value: 'secondary'
                },
            ],
            languages: [],
            languageIds: [],
            documents: [],
            documentDescription: '',
            documentFile: null,
            documentOriginalName: '',
            documentUploading: false,
            documentsLoading: false,
            // Multi-parent management
            linkParentDialog: false,
            linkParentChildId: null,
            linkParentSearchQuery: '',
            linkParentSearchResults: [],
            linkParentSelectedUser: null,
            linkParentRole: 'secondary',
            linkParentLoading: false,
            childParentsDialog: false,
            childParentsData: [],
            childParentsChildName: '',
            childParentsLoading: false,
        }
    },
    userService: null,
    languageService: null,
    streetService: null,
    childService: null,
    documentService: null,
    parentChildService: null,
    created() {
        this.userService = new UserService();
        this.languageService = new LanguageService();
        this.streetService = new StreetService();
        this.childService = new ChildService();
        this.documentService = new DocumentService();
        this.parentChildService = new ParentChildService();
        this.initFilters();
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.permissionDenied = user.role === 1;

        this.getAll();
        this.getAllLanguage();
        this.getAllStreet();
    },
    methods: {
        formatDate(date) {
            let d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        },
        getAll() {
            this.userService.getAll().then(response => {
                this.total = response.data.total
                this.users = response.data.data
                this.loading = false;
            });
        },
        getAllLanguage() {
            this.languageService.getAll().then(response => {
                response.data.data.map((language) => {
                    this.languages.push({
                        name: language.name, id: language.id
                    })
                });
            });
        },
        getAllStreet() {
            this.streetService.getAll().then(response => {
                this.streets = response.data.data.map((street) => ({
                    name: street.name, id: street.id
                }));
            });
        },
        hideDialog() {
            this.userDialog = false;
            this.submitted = false;
        },
        saveChild() {
            this.childSubmitted = true;
            this.childLoading = true;

            this.childService.update(this.child.id, {
                firstName: this.child.firstName,
                lastName: this.child.lastName,
                howToCall: this.child.howToCall,
                phoneNumber: this.child.phoneNumber,
                specialRequirements: this.child.specialRequirements,
                gender: parseInt(this.child.genderSelect.value),
                acclimatization: this.child.acclimatization ? this.child.acclimatization : false,
                birthDate: this.child.birthDate instanceof Date ? this.formatDate(this.child.birthDate) : this.child.birthDate,
            }).then(() => {
                this.editChildDialog = false;
                this.showUserDialog = false;
                this.child = {};
                this.getAll()

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A gyermek adatai sikeresen módosultak.',
                    life: 5000
                });

                this.childLoading = false;
            }).catch(e => {
                this.$toast.add({
                    severity: "error",
                    summary: "Sikertelen művelet!",
                    detail: e.response.data.error,
                    life: 6000,
                });

                this.childLoading = false;
            });
        },
        saveChildConnection() {
            this.childConnectionSubmitted = true;
            this.childConnectionsLoading = true;

            this.childService.addConnections(this.child.id, {
                connections: this.childConnections
            }).then(() => {
                this.editChildConnectionsDialog = false;
                this.showUserDialog = false;
                this.child = {};
                this.getAll()

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A gyermek kapcsolattartóinak adatai sikeresen módosultak.',
                    life: 5000
                });

                this.childConnectionsLoading = false;
            }).catch(e => {
                this.$toast.add({
                    severity: "error",
                    summary: "Sikertelen művelet!",
                    detail: e.response.data.error,
                    life: 6000,
                });

                this.childConnectionsLoading = false;
            });
        },
        saveUser() {
            this.submitted = true;
            this.loading = true;

            if (this.user.name.trim()) {
                let user = {
                    firstName: this.user.firstName,
                    lastName: this.user.lastName,
                    policyAccepted: this.user.policyAccepted ? this.user.policyAccepted : false,
                    privacyPolicyAccepted: this.user.privacyPolicyAccepted ? this.user.privacyPolicyAccepted : false,
                    newsletter: this.user.newsletter ? this.user.newsletter : false,
                    unexcusedAbsence: this.user.unexcusedAbsence ? 1 : 0,
                    isForbidden: this.user.isForbidden ? this.user.isForbidden : false,
                    isActive: this.user.status === 'active' || this.user.status.value === 'active',
                    languages: this.languageIds.map((lang) => lang),
                    zipCode: this.user.contactDetail.zipCode,
                    street: this.user.contactDetail.street,
                    houseNumber: this.user.contactDetail.houseNumber,
                    floor: this.user.contactDetail.floor,
                    door: this.user.contactDetail.door,
                    phoneNumber: this.user.contactDetail.phoneNumber
                };

                let d = new Date(this.actualDate),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                user.activatedAt = [year, month, day].join('-');

                this.userService.update(this.user.id, user).then(() => {
                    this.userDialog = false;
                    this.user = {};
                    this.getAll()

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Sikeres művelet!',
                        detail: 'A felhasználó adatai sikeresen módosultak.',
                        life: 5000
                    });

                    this.loading = false;
                }).catch(e => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Sikertelen művelet!",
                        detail: e.response.data.error,
                        life: 6000,
                    });

                    this.loading = false;
                });
            }
        },
        edit(user) {
            let d = new Date(),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            this.user = {...user};
            this.actualDate = this.user.activatedAt ? this.user.activatedAt : [year, month, day].join('-');
            this.languageIds = this.user.languages.map(lang => lang.id);
            this.userDialog = true;
        },
        show(user) {
          this.userService.get(user.id).then(response => {
            this.user = response.data;
            this.filteredApplies = this.user.applies || [];
            this.applyFilterDateFrom = null;
            this.applyFilterDateTo = null;
            this.applyFilterApplicantType = null;
            this.showUserDialog = true;
            this.loadDocuments(user.id);
          });
        },
        loadDocuments(userId) {
            this.documentsLoading = true;
            this.documentService.list(userId).then(response => {
                this.documents = response.data.data;
                this.documentsLoading = false;
            }).catch(() => {
                this.documents = [];
                this.documentsLoading = false;
            });
        },
        onDocumentFileSelect(event) {
            const file = event.target.files[0];
            if (!file) return;

            const maxSizeMB = 10;
            if (file.size > maxSizeMB * 1024 * 1024) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: `A fájl mérete meghaladja a megengedett maximumot (${maxSizeMB} MB). Kérjük, töltsön fel kisebb fájlt.`,
                    life: 6000,
                });
                event.target.value = '';
                return;
            }

            this.documentOriginalName = file.name;
            const reader = new FileReader();
            reader.onload = (e) => {
                this.documentFile = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        uploadDocument() {
            if (!this.documentFile || !this.user.id) return;

            this.documentUploading = true;
            this.documentService.upload(this.user.id, {
                file: this.documentFile,
                originalName: this.documentOriginalName,
                description: this.documentDescription,
            }).then(() => {
                this.documentFile = null;
                this.documentOriginalName = '';
                this.documentDescription = '';
                this.loadDocuments(this.user.id);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A dokumentum feltöltése sikeres volt.',
                    life: 5000
                });

                this.documentUploading = false;
            }).catch(e => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: e.response?.data?.error || 'Hiba történt a feltöltés során.',
                    life: 6000,
                });

                this.documentUploading = false;
            });
        },
        downloadDocument(document) {
            const url = this.documentService.getDownloadUrl(document.id);
            const link = window.document.createElement('a');
            link.href = url;
            link.target = '_blank';

            fetch(url, { headers: authHeader() })
                .then(res => res.blob())
                .then(blob => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    link.href = blobUrl;
                    link.download = document.originalName;
                    link.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
        },
        deleteDocument(document) {
            if (!confirm('Biztosan törölni szeretné ezt a dokumentumot?')) return;

            this.documentService.delete(document.id).then(() => {
                this.loadDocuments(this.user.id);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A dokumentum törlése sikeres volt.',
                    life: 5000
                });
            }).catch(e => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: e.response?.data?.error || 'Hiba történt a törlés során.',
                    life: 6000,
                });
            });
        },
        showChild(child) {
            this.child = {...child};
            this.showChildDialog = true;
        },
        editChild(child) {
            this.child = {...child};
            this.editChildDialog = true;
        },
        showConnections(child) {
            this.child = {...child};

            if (child.connections.length > 0) {
                this.childConnections = child.connections;
            }

            this.editChildConnectionsDialog = true;
        },
        addConnection() {
            this.childConnections.push({
                firstName: '',
                lastName: '',
                phoneNumber: '',
                relationshipType: ''
            });
        },
        deleteConnection(index) {
            this.childConnections.splice(index, 1);
        },
        // === Multi-parent management methods ===
        showChildParents(child) {
            this.childParentsChildName = child.nameHU || child.name;
            this.linkParentChildId = child.id;
            this.childParentsLoading = true;
            this.childParentsDialog = true;

            this.parentChildService.getChildParents(child.id).then(response => {
                this.childParentsData = response.data.data;
                this.childParentsLoading = false;
            }).catch(() => {
                this.childParentsData = [];
                this.childParentsLoading = false;
            });
        },
        openLinkParentDialog() {
            this.linkParentSearchQuery = '';
            this.linkParentSearchResults = [];
            this.linkParentSelectedUser = null;
            this.linkParentRole = 'secondary';
            this.linkParentDialog = true;
        },
        searchParentsForLinking() {
            if (this.linkParentSearchQuery.length < 2) {
                this.linkParentSearchResults = [];
                return;
            }

            this.parentChildService.searchUsers(this.linkParentSearchQuery).then(response => {
                this.linkParentSearchResults = response.data.data.map(u => ({
                    value: u.id,
                    label: `${u.name} (${u.email})`,
                    ...u
                }));
            });
        },
        linkParent() {
            if (!this.linkParentSelectedUser || !this.linkParentChildId) return;

            this.linkParentLoading = true;
            this.parentChildService.linkChild({
                userId: this.linkParentSelectedUser.id || this.linkParentSelectedUser.value,
                childId: this.linkParentChildId,
                role: this.linkParentRole,
            }).then(() => {
                this.linkParentDialog = false;
                this.linkParentLoading = false;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A szülő sikeresen hozzá lett kapcsolva a gyermekhez.',
                    life: 5000
                });

                // Refresh child parents list
                this.showChildParents({ id: this.linkParentChildId, nameHU: this.childParentsChildName });
                // Refresh user data
                if (this.user.id) {
                    this.userService.get(this.user.id).then(response => {
                        this.user = response.data;
                    });
                }
            }).catch(e => {
                this.linkParentLoading = false;
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: e.response?.data?.error || 'Hiba történt.',
                    life: 6000,
                });
            });
        },
        unlinkParentFromChild(parentChildData) {
            if (!confirm(`Biztosan le szeretné választani a szülőt (${parentChildData.userName}) erről a gyermekről?`)) return;

            this.parentChildService.unlinkChild({
                userId: parentChildData.userId,
                childId: parentChildData.childId,
            }).then(() => {
                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A szülő sikeresen le lett választva.',
                    life: 5000
                });

                this.showChildParents({ id: parentChildData.childId, nameHU: this.childParentsChildName });
                if (this.user.id) {
                    this.userService.get(this.user.id).then(response => {
                        this.user = response.data;
                    });
                }
            }).catch(e => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: e.response?.data?.error || 'Hiba történt.',
                    life: 6000,
                });
            });
        },
        toggleHibernation(linkedChildData) {
            this.parentChildService.setHibernation({
                userId: linkedChildData.userId,
                childId: linkedChildData.childId,
                isHibernated: !linkedChildData.isHibernated,
            }).then(() => {
                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: linkedChildData.isHibernated ? 'A szülő aktiválva lett.' : 'A szülő hibernálva lett.',
                    life: 5000
                });

                if (this.user.id) {
                    this.userService.get(this.user.id).then(response => {
                        this.user = response.data;
                        this.filteredApplies = this.user.applies || [];
                    });
                }
            }).catch(e => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: e.response?.data?.error || 'Hiba történt.',
                    life: 6000,
                });
            });
        },
        toggleHibernationFromChildParents(parentChildData) {
            this.parentChildService.setHibernation({
                userId: parentChildData.userId,
                childId: parentChildData.childId,
                isHibernated: !parentChildData.isHibernated,
            }).then(() => {
                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: parentChildData.isHibernated ? 'A szülő aktiválva lett.' : 'A szülő hibernálva lett.',
                    life: 5000
                });

                this.showChildParents({ id: parentChildData.childId, nameHU: this.childParentsChildName });
            }).catch(e => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Sikertelen művelet!',
                    detail: e.response?.data?.error || 'Hiba történt.',
                    life: 6000,
                });
            });
        },
        login(event, { token }) {
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Biztosan szeretne belépni a felhasználó nevében?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Igen',
                rejectLabel: 'Nem',
                accept: () => {
                    this.userService.extendToken(token).then(() => {
                        window.open(getEnvironment().FRONTEND_URL + "admin-login?token=" + token, "_blank");
                    });
                }
            });
        },
        confirmDelete(user) {
            this.user = user;
            this.deleteUserDialog = true;
        },
        deleteUser() {
            this.loading = true;
            this.deleteLoading = true;

            this.userService.delete(this.user.id).then(() => {
                this.deleteUserDialog = false;
                this.user = {};
                this.getAll()

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'A felhasználó törlése sikeres volt.',
                    life: 5000
                });

                this.loading = false;
                this.deleteLoading = false;
            }).catch(e => {
                this.$toast.add({
                    severity: "error",
                    summary: "Sikertelen művelet!",
                    detail: e.response.data.error,
                    life: 6000,
                });

                this.loading = false;
                this.deleteLoading = false;
            });
        },
        findIndexById(id) {
            let index = -1;
            for (let i = 0; i < this.users.length; i++) {
                if (this.users[i].id === id) {
                    index = i;
                    break;
                }
            }
            return index;
        },
        async exportToExcel() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet 1');
            worksheet.columns = [
                { header: '#', key: 'id', width: 10 },
                { header: 'Felhasználónév', key: 'userName', width: 40 },
                { header: 'Név', key: 'nameHU', width: 40 },
                { header: 'E-mail cím', key: 'email', width: 40 },
                { header: 'Regisztráció dátuma', key: 'createdAt', width: 20 },
                { header: 'Státusz', key: 'status', width: 10 },
                { header: 'Szerep', key: 'parentRole', width: 15 }
            ];

            const selectedProperties = worksheet.columns.map(column => column.key);
            const data = this.users === null ? [] : this.users;
            const modifiedData = data.map(obj =>
                selectedProperties.reduce((acc, prop) => {
                acc[prop] = obj[prop];
                return acc;
                }, {})
            );

            modifiedData.forEach(row => {
                worksheet.addRow(Object.values(row));
            });

            const statusColumnIndex = selectedProperties.indexOf('status');
            if (statusColumnIndex !== -1) {
                worksheet.getColumn(statusColumnIndex + 1).eachCell((cell, rowNumber) => {
                if (rowNumber > 1) {
                    cell.value = cell.value === 'active' ? 'Aktív' : 'Inaktív';
                }
                });
            }

            const parentRoleColumnIndex = selectedProperties.indexOf('parentRole');
            if (parentRoleColumnIndex !== -1) {
                worksheet.getColumn(parentRoleColumnIndex + 1).eachCell((cell, rowNumber) => {
                    if (rowNumber > 1) {
                        if (cell.value === 'primary') {
                            cell.value = 'Elsődleges';
                        } else if (cell.value === 'secondary') {
                            cell.value = 'Másodlagos';
                        } else {
                            cell.value = '—';
                        }
                    }
                });
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const today = dayjs().format('YYYY-MM-DD');
            const filename = `${today}_felhasznalok.xlsx`;
            a.download = filename;
            a.click();
        },
        confirmDeleteSelected() {
            this.deleteUsersDialog = true;
        },
        deleteSelectedUsers() {
            this.users = this.users.filter(val => !this.selectedUsers.includes(val));
            this.deleteUsersDialog = false;
            this.selectedUsers = null;
            this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
        },
        filterAppliesByDate() {
            if (!this.user.applies) {
                this.filteredApplies = [];
                return;
            }

            let filtered = [...this.user.applies];

            if (this.applyFilterDateFrom) {
                const fromDate = new Date(this.applyFilterDateFrom);
                fromDate.setHours(0, 0, 0, 0);

                filtered = filtered.filter(apply => {
                    const applyDate = new Date(apply.applyDate);
                    return applyDate >= fromDate;
                });
            }

            if (this.applyFilterDateTo) {
                const toDate = new Date(this.applyFilterDateTo);
                toDate.setHours(23, 59, 59, 999);

                filtered = filtered.filter(apply => {
                    const applyDate = new Date(apply.applyDate);
                    return applyDate <= toDate;
                });
            }

            if (this.applyFilterApplicantType) {
                filtered = filtered.filter(apply => {
                    if (this.applyFilterApplicantType === 'parent') {
                        return !apply.child && apply.parent;
                    } else if (this.applyFilterApplicantType === 'child') {
                        return apply.child;
                    }
                    return true;
                });
            }

            this.filteredApplies = filtered;
        },
        clearApplyDateFilter() {
            this.applyFilterDateFrom = null;
            this.applyFilterDateTo = null;
            this.applyFilterApplicantType = null;
            this.filteredApplies = this.user.applies || [];
        },
        initFilters() {
            this.filters = {
                'global': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'status': {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS
                },
                'parentRole': {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS
                },
                'email': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'nameHU': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'userName': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/demo/badges.scss';

::v-deep(.p-datatable .p-datatable-tbody > tr:has(.p-badge-warning)) {
    background-color: #fff3cd !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr:has(.p-badge-warning):hover) {
    background-color: #ffe69c !important;
}
</style>
